/* eslint-disable */
// jQuery

window.$ =  require('jquery');

// Local storage
window.$.localStorage = require("js-storage").localStorage;
// Modernizr
import "./modernizr.js";
// jQuery easing
import "jquery.easing/jquery.easing.min.js";
// Whirl
// import "../node_modules/whirl/dist/whirl.css";
// Animo
// import "animo/animo.js";
// Font Awesome
import "font-awesome/css/font-awesome.min.css";
// Animate.CSS
import "animate.css/animate.min.css";

//import '../node_modules/jquery/dist/jquery.min.js';
// Wizard (jquery.steps)
import '../node_modules/jquery-steps/build/jquery.steps.min.js';
// Validation
import '../node_modules/jquery-validation/dist/jquery.validate.js';

// Simple line icons
import "simple-line-icons/css/simple-line-icons.css";

// Parsley
import '../node_modules/parsleyjs/dist/parsley.min.js';

// Input Mask
//import '../node_modules/inputmask/dist/jquery.inputmask.bundle.js';






// WEBPACK FOOTER //
// ./src/Vendor.js